/**
 * Teclado y normalización E.164 Perú compartidos entre Marcador y FAB.
 */

import { playDtmfKey } from '@/lib/dtmfKeypad';
import { normalizeDialInputToE164 } from '@/lib/phone/normalizeLeadPhone';

export const DIAL_PAD_ROWS: string[][] = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
];

/** Letras ITU E.161 (solo UI del marcador flotante estilo móvil). */
export const DIAL_PAD_LETTERS: Record<string, string> = {
  '1': '',
  '2': 'ABC',
  '3': 'DEF',
  '4': 'GHI',
  '5': 'JKL',
  '6': 'MNO',
  '7': 'PQRS',
  '8': 'TUV',
  '9': 'WXYZ',
  '0': '+',
  '*': '',
  '#': '',
};

export const DIAL_PAD_FLAT = DIAL_PAD_ROWS.flat();

/** Convierte entrada local a E.164 (Perú: 9 dígitos 9… → +51…). */
export function normalizeDialPhoneToE164(value: string): string {
  return normalizeDialInputToE164(value);
}

const VIBRATE_MS = 12;

/** DTMF + vibración corta (feedback táctil opcional). */
export function dialPadTapFeedback(digit: string): void {
  playDtmfKey(digit);
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    try {
      navigator.vibrate(VIBRATE_MS);
    } catch {
      /* noop */
    }
  }
}
